module.exports = __webpack_public_path__ + "img/patrolConfiguration.e4f5672e.png";